module.exports = __webpack_public_path__ + "img/orange_038.b4175ad3.png";